import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 查询小区/机构
export function queryorgcommunity () {
  return request({
    url: '/queryorgcommunity',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新建小区/机构
export function addorgcommunity (data) {
  return request({
    url: '/addorgcommunity',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新小区/机构
export function updateorgcommunity (data) {
  return request({
    url: '/updateorgcommunity',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除组织
export function deleteorgcommunity (data) {
  return request({
    url: '/deleteorgcommunity',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/community.js